/**
 * Primitive colour palette — the single source of truth for brand colour.
 * Consumed three ways, all generated from this one file:
 */
export const paletteTokens = {
    white: '#FFFFFF',
    black: '#000000',
    grey: {
        50: '#F6F6F2',
        100: '#EAEAE6',
        200: '#D6D6D2',
        300: '#BBBBB7',
        400: '#9F9F9B',
        500: '#8A8A86',
        600: '#7C7C78',
        700: '#656561',
        800: '#52524E',
        900: '#43433F'
    },
    red: {
        100: '#FFEBEB',
        300: '#FBA4A4',
        500: '#FF6F6F',
        700: '#E41414',
        900: '#800707'
    },
    pink: {
        50: '#FFE5F0',
        100: '#FFC3DC',
        300: '#FF6BA9',
        500: '#DC186A',
        700: '#8F1045',
        900: '#570728'
    },
    salmon: {
        50: '#FFEAE5',
        100: '#FFCDC3',
        300: '#FF846B',
        500: '#DC3918',
        700: '#8F2510',
        900: '#571407'
    },
    orange: {
        50: '#FFF5E5',
        100: '#FFE8C3',
        300: '#FFB246',
        500: '#DE7905',
        700: '#974B08',
        900: '#592905'
    },
    lemon: {
        50: '#FDFFE5',
        100: '#FCFFC3',
        300: '#FFFC53',
        500: '#E2D701',
        700: '#9F9700',
        900: '#595505'
    },
    yellow: {
        50: '#FFF2CC',
        100: '#FFE188',
        200: '#FFCF44',
        300: '#FFBE00',
        400: '#DFA600',
        500: '#BF8F00',
        600: '#9F7700',
        700: '#805F00',
        800: '#604700',
        900: '#403000'
    },
    green: {
        100: '#E8F6EC',
        300: '#B4E2C1',
        500: '#21C64F',
        700: '#168F3B',
        900: '#0F602D'
    },
    chartreuse: {
        50: '#F5FFE5',
        100: '#E8FFC3',
        300: '#D6FF64',
        500: '#A2C347',
        700: '#496206',
        900: '#2F3E06'
    },
    teal: {
        50: '#EDFFFC',
        100: '#D2FFF8',
        300: '#46FAE0',
        500: '#55CFBD',
        700: '#136D60',
        900: '#084833'
    },
    cyan: {
        50: '#EBF9FF',
        100: '#D7F4FF',
        200: '#6AE1FF',
        300: '#45DAFF',
        400: '#45AACB',
        500: '#449ABA',
        600: '#1D6784',
        700: '#0F5672',
        800: '#0A445A',
        900: '#083D51'
    },
    blue: {
        50: '#EDF7FF',
        100: '#78C5FF',
        200: '#3298FF',
        300: '#0074E8',
        400: '#0063C5',
        500: '#0051A2',
        600: '#00478E',
        700: '#00366C',
        800: '#002851',
        900: '#001428'
    },
    navy: {
        50: '#F4F6F7',
        100: '#D7DCE1',
        200: '#BAC3CB',
        300: '#9DA9B4',
        400: '#80909E',
        500: '#647687',
        600: '#475D70',
        700: '#2B4359',
        800: '#182C3E',
        900: '#09141F'
    },
    purple: {
        50: '#F7F5FF',
        100: '#E5DFFF',
        300: '#B09DFF',
        500: '#7660D1',
        700: '#3E2F7C',
        900: '#1A0B57'
    },
    gold: {
        50: '#FCF6E6',
        100: '#F3E0AC',
        200: '#E9CA73',
        300: '#DBB239',
        400: '#CC9900',
        500: '#B68800',
        600: '#9F7700',
        700: '#886500',
        800: '#705300',
        900: '#574000'
    },
    slate: {
        50: 'rgba(0, 40, 81, 0.05)',
        100: 'rgba(0, 40, 81, 0.10)',
        200: 'rgba(0, 40, 81, 0.20)',
        300: 'rgba(0, 40, 81, 0.30)',
        400: 'rgba(0, 40, 81, 0.40)',
        500: 'rgba(0, 40, 81, 0.50)',
        600: 'rgba(0, 40, 81, 0.60)',
        700: 'rgba(0, 40, 81, 0.70)',
        800: 'rgba(0, 40, 81, 0.80)',
        900: 'rgba(0, 40, 81, 0.90)'
    },
    'util-yellow': {
        100: '#FFF2CC',
        300: '#FFE188',
        500: '#FFC61F',
        700: '#BF8F00',
        900: '#705300'
    }
};
